import { COLORS } from 'helpers/globals'

const clip = {
  position: 'absolute',
  background: 'white',
  border: `1px solid ${COLORS.quaternary}`,
  width: '100%'
}

const topClip = {
  ...clip,
  top: 0,
  left: 0,
  borderBottom: 'none'
}

const bottomClip = {
  ...clip,
  bottom: 0,
  right: 0,
  borderTop: 'none'
}

export default {
  container: {
    position: 'relative',
    backgroundRepeat: 'no-repeat',
    height: 314
  },
  topClip,
  bottomClip,
  rightClip: {
    ...topClip,
    borderRight: 'none',
    height: '100%'
  },
  leftClip: {
    ...bottomClip,
    borderLeft: 'none',
    height: '100%'
  },
  hide: { display: 'none' },
  noBorder: { border: 'none !important' }
}



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovImage/style.js